import { createContext, useContext } from 'react';
import { ACCEPTED_STATUS_OPTION, REGISTERED_STATUS_OPTION } from 'utils/consts/consts';
import { RegistryType } from 'api/dict/params';
import { FiltersContextType, FiltersType } from './types';

export const defaultFilters: FiltersType = {
  feedRegistry: { registryStatus: REGISTERED_STATUS_OPTION },
  feedRequests: { gosRegistrationRejected: false },
  adversePetitions: undefined,
  prescriptions: { prescriptionPaper: false },
  paperPrescriptions: { prescriptionPaper: true },
  pharmRequests: { registryType: RegistryType.REQUEST },
  pharmRegistry: { registryType: RegistryType.PERMIT },
  consignmentsRegistry: undefined,
  dpoRegistry: undefined,
  gmoRequests: { registryStatus: ACCEPTED_STATUS_OPTION },
  gmoRegistry: undefined,
  gmoInactive: undefined,
  gmProductRequests: { registryStatus: ACCEPTED_STATUS_OPTION },
  gmProductRegistry: undefined,
  gmProductInactive: undefined,
  gmpRegistry: undefined,
};

export const FiltersContext = createContext<FiltersContextType>({
  filters: defaultFilters,
  handleSetFilters: () => {},
});

export const useFiltersContext = () => {
  const contextValue = useContext(FiltersContext);
  if (!contextValue) {
    throw new Error('FiltersContext.Provider is not found in tree');
  }
  return contextValue;
};
